/* Stock-linked individual flavours; native Shopify quantity discounts, never bundle parent SKUs. */
(() => {
  const config=window.GLOWMING_SHOP;
  const action=document.querySelector('#add-box');
  const status=document.querySelector('#cart-status');
  const expiry=Date.parse(config.endsAt);
  const root=(config.root||'/').replace(/\/?$/,'/');
  const endpoint=path=>root+path;
  const eligible=new Set(Object.values(config.products).map(p=>Number(p.id)).filter(Boolean));
  let busy=false, added=false;
  const fail=message=>{status.textContent=message;};
  const jsonRequest=async(path,body)=>{
    const response=await fetch(endpoint(path),{credentials:'same-origin',headers:{'Accept':'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{method:'POST',body:JSON.stringify(body)}:{})});
    const data=await response.json();
    if(!response.ok)throw new Error(data.description||'Please try again in a moment.');
    return data;
  };
  function saleOpen(){return Date.now()<expiry;}
  function refreshDeadline(){
    const deadline=document.querySelector('#sale-deadline');
    if(!saleOpen()){
      if(deadline)deadline.textContent='Black Friday offer has ended';
      const announcement=document.querySelector('.announcement > span');if(announcement)announcement.textContent='OFFER ENDED';
      action.disabled=true;action.textContent='OFFER ENDED';
      document.querySelector('#review').disabled=true;
      document.querySelector('#builder-status').textContent='This Black Friday offer has ended. Visit your cart for current product prices.';
    }
  }
  refreshDeadline();setInterval(refreshDeadline,30000);
  // A new review after an error is allowed; never resubmit a successfully added box.
  action.addEventListener('click',async()=>{
    if(busy||added)return;
    if(!saleOpen()){refreshDeadline();return;}
    if(config.currency!=='AUD'){fail('These offers are in AUD. Please select Australia / AUD before adding your box.');return;}
    if(total()!==size){fail('Please finish choosing your flavours first.');return;}
    const chosen=flavours.filter(p=>mix[p.handle]>0);
    if(chosen.some(p=>!config.products[p.handle]?.available||config.products[p.handle].price!==4499)){
      fail('A selected product is unavailable or its price has changed. Please refresh and review your mix.');return;
    }
    busy=true;action.disabled=true;action.textContent='ADDING YOUR FLAVOURS…';fail('');
    const group=crypto.randomUUID();
    let submitted=false;
    try{
      const items=chosen.map(p=>({id:Number(config.products[p.handle].id),quantity:mix[p.handle],properties:{'_Glowming_mix':group}}));
      // One atomic add request; no retries after an ambiguous network failure.
      submitted=true;
      await jsonRequest('cart/add.js',{items});
      added=true;
      const cart=await jsonRequest('cart.js');
      const own=cart.items.filter(line=>line.properties?._Glowming_mix===group);
      const count=cart.items.filter(line=>eligible.has(Number(line.variant_id))&&!line.selling_plan_allocation).reduce((n,line)=>n+line.quantity,0);
      const unit=count>=10?2490:count>=6?2983:count>=3?3300:4499;
      const expected=items.reduce((n,item)=>n+item.quantity,0);
      const actual=own.reduce((n,line)=>n+line.quantity,0);
      const paid=own.reduce((n,line)=>n+line.final_line_price,0);
      if(cart.currency!=='AUD'||actual!==expected||paid>unit*expected){
        fail('Your flavours were added, but please check the discount in your cart before checkout.');
        action.textContent='VIEW MY CART ↗';action.disabled=false;action.onclick=()=>location.assign(endpoint('cart'));return;
      }
      location.assign(endpoint('cart'));
    }catch(error){
      // A request can succeed even if the connection drops: offer cart inspection, never duplicate it.
      fail((submitted?'Please check your cart before trying again. ':'')+error.message);
      action.textContent='CHECK MY CART ↗';action.disabled=false;
      action.onclick=()=>location.assign(endpoint('cart'));
      added=true;
    }finally{busy=false;}
  });
})();
